/**
 * Типы узлов канвы, которые не входят в нотацию ArchiMate
 * (не концепты модели и не элементы Open Exchange).
 */
export const STICKER = 'Sticker';

export const CANVAS_ONLY_NODE_TYPES = Object.freeze([STICKER]);

export const STICKER_SHAPE_ID = 'canvas:sticker';

/** Квадратный стикер; ширина как MIN_ELEMENT_WIDTH, чтобы дроп с палитры не сплющивал. */
export const STICKER_DEFAULT_SIZE = Object.freeze({width: 150, height: 150});

/** Miro light_yellow (#FFF9B1). */
export const DEFAULT_STICKER_COLOR = '#FFF9B1';

export const DEFAULT_STICKER_FILL_RGB = Object.freeze({r: 255, g: 249, b: 177, a: 100});

export function isCanvasOnlyNodeType(type) {
	if (!type) return false;
	const base = String(type).split(':').pop();
	return CANVAS_ONLY_NODE_TYPES.includes(base);
}
